// extracted by mini-css-extract-plugin
module.exports = {"root":"FileBtn_root__3_Tuo","disabled":"FileBtn_disabled__3UDUJ","warn":"FileBtn_warn__2VytA","fade":"FileBtn_fade__3dw6F"};